<template>
  <div>
    <university-type-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.university_type_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import UniversityTypeIndex from "./UniversityTypeIndex";
export default {
  name: "Index",
  data() {
    return {
      serviceName: "university-types",
      formSearch: [
        {
          label: this.$t("university_type.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("university_type.id"),
        name: this.$t("university_type.name"),
        description: this.$t("university_type.description"),
        created_at: this.$t("university_type.created_at"),
        updated_at: this.$t("university_type.updated_at")
      }
    };
  },
  components: { UniversityTypeIndex },
  methods: {},
  mounted() {}
};
</script>
